// Mock data for IELTS Dashboard

export const scoreData = {
  averageScore: "7 / 9",
  targetScore: "7 / 9",
  examIn: "08 Days"
};

export const fullTests = [
  {
    id: 1,
    title: "Cambridge - 11 Test 01",
    time: "2h:30m",
    difficulty: "Easy"
  },
  {
    id: 2,
    title: "Cambridge - 11 Test 01",
    time: "2h:30m",
    difficulty: "Easy"
  },
  {
    id: 3,
    title: "Cambridge - 11 Test 01",
    time: "2h:30m",
    difficulty: "Easy"
  },
  {
    id: 4,
    title: "Cambridge - 11 Test 01",
    time: "2h:30m",
    difficulty: "Easy"
  },
  {
    id: 5,
    title: "Cambridge - 11 Test 01",
    time: "2h:30m",
    difficulty: "Easy"
  }
];

export const testFilters = [
  { value: "Cambridge", label: "Cambridge" },
  { value: "Practice Plus", label: "Practice Plus" },
  { value: "Recent Actual Test", label: "Recent Actual Test" }
];

export const normalizeIeltsTestKind = (value) => {
  const normalizedValue = String(value || '').trim();
  const compactValue = normalizedValue.toLowerCase().replace(/[^a-z0-9]/g, '');

  if (!compactValue) return 'Cambridge';
  if (compactValue === 'britishcouncil') return 'Practice Plus';
  if (compactValue === 'practiceplus') return 'Practice Plus';
  if (compactValue === 'idp') return 'Recent Actual Test';
  if (compactValue === 'recentactualtest') return 'Recent Actual Test';
  if (compactValue === 'cambridge') return 'Cambridge';

  return normalizedValue;
};

export const sections = [
  {
    id: 1,
    title: "Listening",
    count: 40,
    icon: "listening"
  },
  {
    id: 2,
    title: "Reading",
    count: 40,
    icon: "reading"
  },
  {
    id: 3,
    title: "Writing",
    count: 40,
    icon: "writing"
  },
  {
    id: 4,
    title: "Speaking",
    count: 40,
    icon: "speaking"
  }
];

export const sectionalTests = [
  {
    id: 1,
    title: "Cambridge - 11 Test - 01 Listening",
    time: "00:30m",
    difficulty: "Easy"
  },
  {
    id: 2,
    title: "Cambridge - 11 Test - 01 Listening",
    time: "00:30m",
    difficulty: "Hard"
  },
  {
    id: 3,
    title: "Cambridge - 11 Test - 01 Listening",
    time: "00:30m",
    difficulty: "Med"
  },
  {
    id: 4,
    title: "Cambridge - 11 Test - 01 Listening",
    time: "00:30m",
    difficulty: "Med"
  }
];
